type RunContext = 'event-cast' | 'seek';

interface ClientFixMap {
  indentifiers: string[];
  fixCb: (doc: Document) => void;
  runContext: RunContext;
}

const clientFixMap: ClientFixMap[] = [
  {
    indentifiers: ['apphumucom', 'app.humu.com'],
    fixCb: humuStyleFix,
    runContext: 'event-cast',
  },
  {
    indentifiers: ['appsetsailco', 'app.setsail.co'],
    fixCb: setSailTableFix,
    runContext: 'event-cast',
  },
  {
    indentifiers: ['liveprognosiscom', 'live.prognosis.com'],
    fixCb: irYFilesTooltipFix,
    runContext: 'seek',
  },
];

export const applyClientSpecificFixes = (
  url: string,
  contextDoc: Document,
  runContext: RunContext
) => {
  clientFixMap.forEach((clientFix) => {
    const urlMatches = clientFix.indentifiers.some((identifier) =>
      url?.includes(identifier)
    );
    const runContextMatches = clientFix.runContext === runContext;

    if (urlMatches && runContextMatches) {
      clientFix.fixCb(contextDoc);
    }
  });
};

function humuStyleFix(doc: Document) {
  const svg = doc.querySelector(
    '[data-testid="coachHeader"] svg'
  ) as SVGElement;

  if (svg) {
    const screenWidth = doc.defaultView.innerWidth || window.innerWidth;
    svg.setAttribute('width', String(screenWidth));
    svg.setAttribute('viewBox', `0 0 ${screenWidth} 548`);
    const image = svg.querySelector('image');
    const imgWidth = Number(image.getAttribute('width'));
    image.setAttribute('x', String((screenWidth - imgWidth) / 2));
  }

  const menu = doc.querySelector(
    '.modal-root div[data-placement="bottom"]'
  ) as HTMLElement;

  if (
    menu?.innerHTML.toLowerCase().includes('sign out') &&
    menu.innerHTML.toLowerCase().includes('view profile')
  ) {
    menu.style.transform = '';
    menu.style.top = '136px';
    menu.style.left = 'calc(100vw - 266px)';
  }
}

type HTMLElementEvent<T extends HTMLElement> = Event & {
  target: T;
};

function setSailTableFix(doc: Document) {
  const tableBody = doc.querySelector('.BaseTable__body');
  const tableHeader = doc.querySelector('.BaseTable__header');
  const tableLeftColumn = doc.querySelector(
    '.BaseTable__table-frozen-left .BaseTable__body'
  );

  if (tableBody && tableHeader && tableLeftColumn) {
    // replacing node to clean old event listeners
    const tBody = tableBody.cloneNode(true) as HTMLDivElement;
    tableBody.replaceWith(tBody);
    tBody.addEventListener(
      'scroll',
      (e: HTMLElementEvent<HTMLDivElement>) => {
        tableHeader.scrollLeft = e.target.scrollLeft;
        tableLeftColumn.scrollTop = e.target.scrollTop;
      },
      true
    );
  }
}

function irYFilesTooltipFix(contextDoc: Document) {
  const yTooltipElements = contextDoc.getElementsByClassName('yfilestooltip');
  if (yTooltipElements.length === 0) {
    return;
  }

  Array.from(yTooltipElements).forEach((yTooltipElement) => {
    yTooltipElement.setAttribute('style', 'display: none;');
  });
  return;
}
